module.exports = __webpack_public_path__ + "static/media/ic-remove.43d86f75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/EquipmentListItem/ic-remove.svg
// module id = 1065
// module chunks = 0